import React from "react";
import { CheckCircle } from "@phosphor-icons/react";

const FEATURES = [
  "Expanded text & voice translations",
  "Expanded receipt + menu OCR scans",
  "Faster, higher-quality AI model",
  "Priority AI queue",
  "Saved phrasebook access",
  "Offline language packs",
  "Exclusive Pro features",
];

export default function PaywallIncludes() {
  return (
    <div className="bg-white rounded-2xl shadow-soft border border-navy/10 p-5">
      <div className="text-navy-soft text-[11px] uppercase tracking-[0.2em] font-jakarta font-bold mb-3 flex items-center gap-2">
        <img
          src="/assets/pro-crown-badge.png"
          alt=""
          aria-hidden="true"
          width={22}
          height={22}
          className="object-contain"
        />
        Pro includes
      </div>
      <ul className="space-y-2.5">
        {FEATURES.map((t) => (
          <li
            key={t}
            className="flex items-start gap-3 font-jakarta font-semibold text-navy text-base leading-snug"
          >
            <CheckCircle
              size={20}
              weight="fill"
              color="#2E7D5A"
              className="shrink-0 mt-0.5"
            />
            {t}
          </li>
        ))}
      </ul>
    </div>
  );
}
